import { z } from "zod";

export const traxUserSchema = z.object({
	userId: z.string(),
	firstName: z.string().nullable(),
	lastName: z.string().nullable(),
	email: z.string(),
	role: z.string(),
	roleId: z.number().optional(),
	mobilePhoneNumber: z.string().optional(),
	rowId: z.number().optional(),
	isMfaEnabled: z.boolean().optional(),
});

export type TraxUser = z.infer<typeof traxUserSchema>;

export const traxUserListSchema = z.array(traxUserSchema);

export const deleteVendorSchema = z.object({
	userId: z.number(),
});

// Vendor user mutation endpoints (Add/Edit/Delete VendorWebUser) all return
// 200 OK with an empty body on success. Accept null/undefined/empty object so
// validation passes regardless of how the server represents "no content".
export const vendorUserMutationResponseSchema = z.union([
	z.null(),
	z.undefined(),
	z.object({}).passthrough(),
]);

export type UseVendorColumnsOptions = {
	onEdit: (user: TraxUser) => void;
	onDelete: (user: TraxUser) => void;
	currentUserRole: string;
};
